export const AUTHENTICATION_TYPES = {
  NATIVE: 1,
  WINDOWS: 2,
  SAML2: 3,
  OIDC: 4,
};
